import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useSyncExternalStore } from 'react';
function subscribe(callback) {
    window.addEventListener('online', callback);
    window.addEventListener('offline', callback);
    return () => {
        window.removeEventListener('online', callback);
        window.removeEventListener('offline', callback);
    };
}
function getSnapshot() {
    return typeof navigator !== 'undefined' ? navigator.onLine : true;
}
export function Detector({ onChange, render, }) {
    const isOnline = useSyncExternalStore(subscribe, getSnapshot, () => true);
    // As soon as the online status changes in the browser, trigger the Redux action in the layout.
    useEffect(() => {
        if (onChange) {
            onChange(isOnline);
        }
    }, [isOnline, onChange]);
    // Call the render method if it exists (important for backward compatibility)
    if (render) {
        return _jsx(_Fragment, { children: render({ online: isOnline }) });
    }
    return null;
}
export function Online({ children }) {
    const isOnline = useSyncExternalStore(subscribe, getSnapshot, () => true);
    return isOnline ? _jsx(_Fragment, { children: children }) : null;
}
export function Offline({ children }) {
    const isOnline = useSyncExternalStore(subscribe, getSnapshot, () => true);
    return !isOnline ? _jsx(_Fragment, { children: children }) : null;
}
